/* global axios */
import ApiClient from './ApiClient';

class CatalogItemsApi extends ApiClient {
  constructor() {
    super('catalog_items', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new CatalogItemsApi();
